import { createContext } from 'react'

import { EMPTY_FUNCTION } from '../constants/common'
import { THEME, THEME_MODE_DEFAULT } from '../constants/themeMode'

export const ThemeMode = createContext({
  changeMode: EMPTY_FUNCTION,
  mode: THEME_MODE_DEFAULT,
  setForcedTheme: EMPTY_FUNCTION,
  theme: THEME.light,
})
